import React from 'react'
import confirmDelete from "../../assets/Images/confirm delete.png";
import { ReactComponent as Cancel } from '../../assets/Icons/Cancel.svg';
import { toast } from 'react-toastify';
import { axiosPostApi } from '../../helpers/interceptorServices';
import { apiList } from '../../helpers/apiList';
import CustomAlert from '../../helpers/CustomAlert';

const DeleteConfirmationVendor = ({ isOpen, onClose, editData, fetchVendorData, handleClose }) => {
  const deleteVendor = () => {
    const loggedInUserName = sessionStorage.getItem('username');
    const requestBody = {
      ...editData,
      username: loggedInUserName,
      status: '3'
    };

    axiosPostApi(apiList.DELETE_VENDOR_DATA, requestBody)
      .then((response) => {
        
        if (response?.status === 200 && response?.data?.respCode === '00') {
          toast.success("Vendor deleted successfully!");
          onClose();
          handleClose();
          fetchVendorData(1);
        } else {
          CustomAlert({
            title: "Failed to delete vendor",
            text: response?.data?.message || 'Invalid credentials. Please try again!',
            icon: 'error',
            confirmButtonText: 'Retry'
          });
          onClose();
          handleClose();
        }
      })
      .catch((error) => {     
        console.error("Error deleting vendor", error);
        toast.error("Failed to delete vendor.");
      });
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal fade show" style={{ display: "block", backgroundColor: 'rgba(0, 0, 0, 0.5)', margin: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: "none" }}>
            <span style={{ marginLeft: 'auto' }} >
              <Cancel onClick={onClose} />
            </span>
          </div>
          <div className="modal-body text-center">
            <img src={confirmDelete} alt="Warning" className="img-fluid mb-3" style={{ width: '250px' }} />
            <h5 className="modal-title">Confirm Deletion?</h5>
            <p className="mt-2">Information will be permanently erased and irretrievable.</p>
          </div>
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              className="btn btn-back"
              data-bs-dismiss="modal"
              onClick={onClose}
            >
              Cancel
            </button>
            <button type="button" className="btn btn-danger" onClick={deleteVendor}>
              Delete Permanently
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteConfirmationVendor